import { ParamLauncherDto } from "./paramLauncherDto";

export class ParamLauncherResponseDto {
    
    paramLauncherDto = new ParamLauncherDto();
       
}


